import React, { Fragment, useState, useEffect, useContext } from "react";
import { UrlServicesContext } from "components/UrlServicesContext";

import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { makeStyles } from "@material-ui/core/styles";
import {
  Assignment,
  Cancel,
  KeyboardArrowRight,
  CheckBoxOutlineBlank,
  CheckBox,
} from "@material-ui/icons/";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Checkbox from "@material-ui/core/Checkbox";
import FormLabel from "@material-ui/core/FormLabel";
import Skeleton from "@material-ui/lab/Skeleton";
import axios from "axios";

import LoadEstimatedAmount from "components/services/LoadEstimatedAmount";
import LoadCatWasteState from "components/services/LoadCatWasteState";
import LoadWeightKg from "components/services/LoadWeightKg";
import LoadTransports from "components/services/LoadTransports";
import LoadWasteUsage from "components/services/LoadWasteUsage";

import cardBodyStyle from "assets/jss/material-dashboard-react/components/cardBodyStyle";

const useStyles = makeStyles(cardBodyStyle);

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

export default function WasteResourcesData(props) {
  const classes = useStyles();
  const [loader, setloader] = useState(true);

  const { urlServices, keyAplication } = useContext(UrlServicesContext);

  const [values, setValues] = useState({
    weightKgName: "",
    weightKg: "",
    weightKgData: "",
    estimatedAmountName: "",
    estimatedAmount: "",
    estimatedAmountData: "",
    transactionType: [],
    transactionTypeData: [],
    wasteStateName: "",
    wasteState: "",
    wasteStateData: "",
    transportsName: "",
    transports: "",
    transportsData: "",
    wasteUsageName: "",
    wasteUsage: "",
    wasteUsageData: "",
    errorFieldTransactionType: false,
    errorFieldWeightKg: false,
    errorFieldestimatedAmount: false,
    errorFieldWasteState: false,
    errorFieldTransports: false,
    errorFieldWasteUsage: false,
  });

  useEffect(() => {
    const dataCat = {
      catalogs: [
        {
          detailName: "catTransactionType",
          codeExclusion: "0",
        },
      ],
    };

    axios
      .post(`${urlServices}catalogsDetails/getMultiplesCatalogs`, dataCat, {
        headers: {
          application: keyAplication,
        },
      })
      .then(
        (response) => {
          if (response.status === 200) {
            setValues({
              ...values,
              transactionType: response.data.catalogs.catTransactionType,
            });
            setloader(false);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }, [urlServices, keyAplication]);

  const handleSend = () => {
    if (values.wasteState === "") {
      setValues({ ...values, errorFieldWasteState: true });
    } else if (values.estimatedAmount === "") {
      setValues({ ...values, errorFieldestimatedAmount: true });
    } else if (values.weightKg === "") {
      setValues({ ...values, errorFieldWeightKg: true });
    } else if (values.transports === "") {
      setValues({ ...values, errorFieldTransports: true });
    } else if (values.transactionTypeData.length === 0) {
      setValues({ ...values, errorFieldTransactionType: true });
    } else {
      let output = [];

      values.transactionTypeData.map((items, i) => {
        output.push({ code: items.code, detailName: items.detailName });
      });

      props.callback({
        save: 1,
        wasteState: values.wasteState,
        estimatedAmount: values.estimatedAmount,
        weightKg: values.weightKg,
        transports: values.transports,
        wasteUsage: values.wasteUsage,
        transactionType: output,
        code: props.data[0].code,
        id: props.data[0].id,
        detailName: props.data[0].detailName,
        cat_id: props.data[0].cat_id,
        wasteStateName: values.wasteStateName,
        estimatedAmountName: values.estimatedAmountName,
        weightKgName: values.weightKgName,
        transportsName: values.transportsName,
        wasteUsageName: values.wasteUsageName,
      });
    }
  };

  const handleClose = () => {
    props.callback({
      save: 0,
      code: props.data[0].code,
      id: props.data[0].id,
      detailName: props.data[0].detailName,
      cat_id: props.data[0].cat_id,
    });
  };

  const getResponseEstimatedAmount = (pro) => {
    if (pro !== null) {
      setValues({
        ...values,
        estimatedAmountName: pro.detailName,
        estimatedAmount: pro.code,
        estimatedAmountData: pro,
        errorFieldestimatedAmount: false,
      });
    } else {
      setValues({
        ...values,
        estimatedAmountName: "",
        estimatedAmount: "",
        estimatedAmountData: pro,
      });
    }
  };

  const getResponseTransactionType = (e, pro) => {
    if (pro.length > 0) {
      setValues({
        ...values,
        transactionTypeData: pro,
        errorFieldTransactionType: false,
      });
    } else {
      setValues({
        ...values,
        transactionTypeData: pro,
      });
    }
  };

  const getResponseWasteState = (pro) => {
    if (pro !== null) {
      setValues({
        ...values,
        wasteStateName: pro.detailName,
        wasteState: pro.code,
        wasteStateData: pro,
        errorFieldWasteState: false,
      });
    } else {
      setValues({
        ...values,
        wasteStateName: "",
        wasteState: "",
        wasteStateData: pro,
      });
    }
  };

  const getResponseWeightKg = (pro) => {
    if (pro !== null) {
      setValues({
        ...values,
        weightKgName: pro.detailName,
        weightKg: pro.code,
        weightKgData: pro,
        errorFieldWeightKg: false,
      });
    } else {
      setValues({
        ...values,
        weightKgName: "",
        weightKg: "",
        weightKgData: pro,
      });
    }
  };

  const getResponseTransports = (pro) => {
    if (pro !== null) {
      setValues({
        ...values,
        transportsName: pro.detailName,
        transports: pro.code,
        transportsData: pro,
        errorFieldTransports: false,
      });
    } else {
      setValues({
        ...values,
        transportsName: "",
        transports: "",
        transportsData: pro,
      });
    }
  };

  const getResponseWasteUsage = (pro) => {
    if (pro !== null) {
      setValues({
        ...values,
        wasteUsageName: pro.detailName,
        wasteUsage: pro.code,
        wasteUsageData: pro,
        errorFieldWasteUsage: false,
      });
    } else {
      setValues({
        ...values,
        wasteUsageName: "",
        wasteUsage: "",
        wasteUsageData: pro,
      });
    }
  };

  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        //  onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <DialogContent dividers style={{ padding: "20px 35px" }}>
          <KeyboardArrowRight className={classes.iconDefault} />{" "}
          <b>{props.data[0].detailName}</b>
          <Grid
            container
            spacing={3}
            style={{
              paddingTop: "1%",
              paddingRight: "3%",
              paddingLeft: "3%",
            }}
          >
            <Grid item xs={12} sm={12}>
              <center>
                <Assignment
                  style={{
                    fontSize: "50px",
                    color: "#000",
                    verticalAlign: "middle",
                  }}
                ></Assignment>
              </center>
            </Grid>
            <Grid item xs={12} sm={6}>
              <LoadCatWasteState
                callback={getResponseWasteState}
                value={values.wasteStateData}
                error={values.errorFieldWasteState}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <LoadEstimatedAmount
                callback={getResponseEstimatedAmount}
                value={values.estimatedAmountData}
                error={values.errorFieldestimatedAmount}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <LoadWeightKg
                callback={getResponseWeightKg}
                value={values.weightKgData}
                error={values.errorFieldWeightKg}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <LoadTransports
                callback={getResponseTransports}
                value={values.transportsData}
                error={values.errorFieldTransports}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <LoadWasteUsage
                callback={getResponseWasteUsage}
                value={values.wasteUsageData}
                error={values.errorFieldWasteUsage}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              {loader ? (
                <Fragment>
                  <FormLabel component="legend">Tipo de Acuerdo</FormLabel>
                  <center>
                  <Skeleton width="100%" height={40} />
                  </center>
                </Fragment>
              ) : (
                <Autocomplete
                  multiple
                  size="small"
                  id="transactionType"
                  options={values.transactionType}
                  value={values.transactionTypeData}
                  disableCloseOnSelect
                  getOptionLabel={(option) => option.detailName}
                  onChange={getResponseTransactionType}
                  getOptionSelected={(option, value) => {
                    return option.detailName === value.detailName;
                  }}
                  renderOption={(option, { selected }) => (
                    <Fragment>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                        color="primary"
                      />
                      {option.detailName}
                    </Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      error={values.errorFieldTransactionType}
                      name="transactionType"
                      //  required
                      label="Tipo de acuerdo"
                      margin="dense"
                    />
                  )}
                />
              )}
            </Grid>
            <Grid item xs={12} sm={12}>
              <br></br>
              <center>
                {" "}
                <Button onClick={handleSend} className={classes.buttonSubmit}>
                  Guardar
                </Button>
              </center>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>
            <Cancel />
          </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}
